import * as types from '../constants/index'

export {
  addModule,
  setActiveModule,
  switchConfig,
  removeConfig,
  deleteModule,
  setUpdate,
  componentSort,
} from './edit'
export const resetTree = () => {
  return {
    type: types.RESET_TREE,
  }
}
export const setBaseInfo = (key: string, value: any) => {
  return {
    type: types.SET_BASE_INFO,
    patch: {
      [key]: value,
    },
  }
}
export const updateTabBase = (id: string, key: string, value: string) => ({
  type: types.SET_TAB_BASE,
  id,
  value,
  name: key,
})

export const setTabInfo = (id: string, key: string, value: string, index: number) => ({
  type: types.SET_TABLIST_INFO,
  id,
  key,
  value,
  index,
})

export const deleteTabChildNode = (id: string, index: number) => ({
  type: types.DELETE_TAB_CHILD_NODE,
  id,
  index,
})

export const setTabActiveIndex = (id: string, index: number) => ({
  type: types.SET_TAB_ACTIVE_INDEX,
  id,
  index,
})

export const deleteTab = info => ({
  type: types.DELETE_TABITEM,
  info,
})

export const setImageBox = (id: string, key = '', value: any, index = 0) => ({
  type: types.SET_IMAGE_BOX,
  id,
  key,
  value,
  index,
})

export const setImageRes = (id: string, fileList: Array<any>) => ({
  type: types.SET_IMAGE_RES,
  id,
  fileList,
})

export const setImageBase = (id: string, key: string, value: any) => ({
  type: types.SET_IMAGE_BASE,
  id,
  key,
  value,
})
export const login = info => ({
  type: types.LOGIN,
  info,
})

export const setProductList = (type: string, data: any, id?: string) => ({
  type: types.SET_PRODUCTSLIST,
  name: type,
  data,
  id,
})
export const setVideoSrc = (id: string, url?: string) => ({
  type: types.SET_VIDEO_SRC,
  id,
  url,
})

export const loginOut = {
  type: types.LOGIN_OUT,
}

export const setRoot = root => ({
  type: types.SET_ROOT,
  root,
})

export const setTextBox = (id: string, key: string, value?: string) => ({
  type: types.SET_TEXT_BOX,
  id,
  key,
  value,
})

export const setMixedBlock = (id: string, name: string, value) => ({
  type: types.SET_MIXED_BLOCK,
  id,
  name,
  value,
})

export const setCommonConfig = (id: string, name: string, value) => ({
  type: types.SET_COMMON_CONFIG,
  id,
  name,
  value,
})

export const resetPanes = () => ({
  type: types.RESET_BASE_PANES,
})

export const getTemplate = () => ({
  type: types.GET_TEMPLATELIST,
})

export const setTabBar = (id: string, name: string, value) => ({
  type: types.SET_TAB_BAR,
  id,
  name,
  value,
})

export const setConference = (id: string, key: string, value: string, index?: number) => ({
  type: types.SET_CONFERENCE,
  id,
  key,
  value,
  index,
})

export const addConferenceTab = (id: string) => ({
  type: types.ADD_CONFERENCE_TAB,
  id,
})
